import { Html } from '@react-three/drei';
import { ControlContext } from 'provider/ControlProvider';
import { memo, useContext } from 'react';

type Props = {
  name?: string;
  pos: Array<number>;
  index?: number;
  scale?: number;
  type?: number;
};

const HtmlNumberTag = ({ name = 'Unknown', pos, scale = 0.1 }: Props) => {
  const { pinInfo } = useContext(ControlContext);
  return pinInfo.index === 0 ? (
    <Html
      scale={scale}
      transform
      sprite
      position={[pos[0], pos[1], pos[2]]}
      className='childed'
    >
      <p className='select-none border-white rounded-full opacity-30 text-5xl text-white text-center'>
        {name}
      </p>
    </Html>
  ) : null;
};

export default memo(HtmlNumberTag);
